export default __webpack_public_path__ + "assets/images/b8a7091c40bc6d16f5849096b18e672d.svg";